import type { DraftType, PlayerStatType } from "../../../../common/types.ts";
import { helpers } from "../util/helpers.ts";
import i18n from "../util/i18n.ts";
import PageTabs from "./PageTabs.tsx";

const tLink = (name: string) =>
	i18n.t(`moreLinks.${name.replace(/ /g, "_")}`, { ns: "ui", defaultValue: name });

export const MoreLinks = (
	props: (
		| {
				type: "team";
				abbrev: string;
				tid: number;
				season?: number;
			}
		| {
				type: "draft";
				draftType: DraftType | "dummy" | undefined;
				abbrev?: string;
				tid?: number;
				season?: number;
			}
		| {
				type: "playerRatings";
				season: number;
			}
		| {
				type: "playerStats";
				season?: number;
				statType?: string;
			}
		| {
				type: "teamStats";
				season: number;
			}
		| {
				type: "awards";
				season?: number;
			}
		| {
				type: "leaders";
				playoffs: "playoffs" | "regularSeason" | "combined";
				season: number | "career" | "all";
				statType: PlayerStatType;
			}
	) & {
		page: string;
		keepSelfLink?: boolean;
	},
) => {
	const { keepSelfLink, page } = props;

	let links: {
		url: (string | number | undefined)[] | string;
		name: string;
		className?: string;
	}[];
	if (props.type === "team") {
		const { abbrev, season, tid } = props;

		links = [
			{
				url:
					season !== undefined
					? ["roster", `${abbrev}_${tid}`, season]
					: ["roster", `${abbrev}_${tid}`],
				name: "Roster",
			},
			{
				// M3-2: the standalone schedule page is retired; the team "Schedule"
				// link now targets the merged dailySchedule season "整季视图" route.
				url: ["daily_schedule", "team", `${abbrev}_${tid}`],
				name: "Schedule",
			},
		];
	} else if (props.type === "draft") {
		links = [];
	} else if (props.type == "awards") {
		links = [];
	} else if (props.type === "playerRatings") {
		links = [];
	} else if (props.type === "playerStats") {
		links = [];
	} else if (props.type === "teamStats") {
		links = [];
	} else if (props.type === "leaders") {
		links = [];
	} else {
		throw new Error("Invalid MoreLinks type");
	}

	const resolvedLinks = links.map(({ className, name, url }, i) => {
		const pageKey = typeof url === "string" ? url : String(url[0]);
		return {
			className,
			href: typeof url === "string" ? url : helpers.leagueUrl(url),
			key: `${pageKey}-${i}`,
			name,
			pageKey,
		};
	});

	const showSelfLink = keepSelfLink || (props.type === "team" && resolvedLinks.length > 1);
	const visibleLinks = resolvedLinks.filter(({ pageKey }) => {
		return showSelfLink || pageKey !== page;
	});

	if (visibleLinks.length === 0) {
		return null;
	}

	if (visibleLinks.length === 1) {
		const link = visibleLinks[0]!;

		return (
			<p className="more-links-single">
				<a className={link.className} href={link.href}>
					{tLink(link.name)}
				</a>
			</p>
		);
	}

	return (
		<PageTabs
			ariaLabel={i18n.t("moreLinks.more", {
				ns: "ui",
				defaultValue: "More:",
			})}
			className="more-links-tabs"
			tabs={visibleLinks.map((link) => ({
				active: link.pageKey === page,
				className: link.className,
				href: link.href,
				key: link.key,
				label: tLink(link.name),
			}))}
		/>
	);
};
